import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#6366f1',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#6366f1',
    colorTextBase: '#2D2D2D',
    colorBgBase: '#FFFFFF',
    colorBgLayout: '#F5F5F0',
    borderRadius: 10,
    fontSize: 14,
    fontFamily: "'Syne', sans-serif",
  },
  components: {
    Button: {
      controlHeight: 34,
      fontWeight: 600,
      primaryColor: '#FFFFFF',
      algorithm: true,
    },
    Input: {
      controlHeight: 34,
      borderRadius: 10,
    },
    Select: {
      controlHeight: 34,
    },
    Layout: {
      siderBg: 'transparent',
      headerBg: 'transparent',
      bodyBg: 'transparent',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkItemSelectedBg: '#6366f1',
      darkItemHoverBg: 'rgba(99, 102, 241, 0.12)',
    },
  },
};

